export default {
  methods: {
    formattedPrice(key) {
      if (Number.isInteger(key)) {
        return "HKD " + key + ".0"
      } else {
        return "HKD " + key;
      }
    }
  }
}